import React, { Component } from 'react';
import { Radio } from '@cloud/atom-ui';

export default class extends Component {
  state = {
    value: this.props.item.defaultValue || -1
  }

  onChange = event => {
    this.setState({
      value: event.target.value || -1
    });
    this.props.change(event.target.value);
  }

  render() {
    const { item } = this.props;
    const { value, options, isEdit } = item;
    return (
      <>
        {
          isEdit
            ? <Radio.Group onChange={this.onChange} value={this.state.value}>
              {
                options.map((radio, index) => (<Radio value={radio.id} key={index}>{radio.name}</Radio>))
              }
            </Radio.Group>
            : <div className="description">{value.name}</div>
        }

      </>

    )
  }
}
